/**
 * 複製文字到剪貼簿。
 * 優先使用 navigator.clipboard（需要 secure context），
 * 失敗時退回 document.execCommand('copy')（在 http:// LAN IP 也能用）。
 */
export async function copyText(text: string): Promise<boolean> {
  if (
    typeof navigator !== "undefined"
    && navigator.clipboard
    && window.isSecureContext
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through
    }
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.width = "1px";
    ta.style.height = "1px";
    ta.style.padding = "0";
    ta.style.border = "none";
    ta.style.outline = "none";
    ta.style.boxShadow = "none";
    ta.style.background = "transparent";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    const prev = document.activeElement as HTMLElement | null;
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    prev?.focus?.();
    return ok;
  } catch {
    return false;
  }
}
